(function () {
    'use strict';

    angular.module("imApp").factory("requisitionsService", ['$ihttp', function ($ihttp) {
        let service = {
            getSetting: function (parms) {
                return $ihttp.post({
                    method: 764,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
